import React, { FC, ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';

const useStyles = makeStyles((theme) => ({
    body: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: theme.shadows[5],
    },
}));

interface CommonModalProps {
  isOpen: boolean;
  handleClose: () => void;
  children: ReactNode;
};

const CommonModal: FC<CommonModalProps> = ({ isOpen, handleClose, children }) => {
    const classes = useStyles();
    return (<Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        disablePortal
        disableEnforceFocus
        disableScrollLock
    >
        <div className={classes.body}>
            {children}
        </div>
    </Modal>);
}

export default CommonModal;
